import ArrowFluff from 'svgs/redesign/right-arrow-decal.svg';

import * as styles from './index.module.scss';

const SignupBullets = () => (
  <div className={styles['signup-bullets-container']}>
    <div className={styles['bullet-container']}>
      <h2>Fast Setup</h2>
      <label>Creating an account takes just 5 minutes. Enter your business information and what areas you service. We&apos;ll take care of the rest.</label>
      <div className={styles['icon-container']}>
        <ArrowFluff />
      </div>
    </div>
    <div className={styles['bullet-container']}>
      <h2>What we do</h2>
      <label>Once your account is set up, we find homeowners who need your services and get them to call you. All you need to do is answer your phone.</label>
      <div className={styles['icon-container']}>
        <ArrowFluff />
      </div>
    </div>
    <div className={styles['bullet-container']}>
      <h2>Detailed Analytics</h2>
      <label>Your dashboard will show you every call you received and lets you track your ROI.</label>
      <div className={styles['icon-container']}>
        <ArrowFluff />
      </div>
    </div>
    <div className={styles['bullet-container']}>
      <h2>We&apos;re here to help</h2>
      <label>
        If you ever get a call that you don&apos;t think is from a qualified homeowner, you can request credit at the click of a button. And, we&apos;re always here to help. Just pick up the phone and
        give us a call.
      </label>
      <div className={styles['icon-container']}>
        <ArrowFluff />
      </div>
    </div>
  </div>
);

export default SignupBullets;
